import { motion, Variants } from 'framer-motion';
import { ReactNode } from 'react';

type PageTransitionProps = {
  children: ReactNode;
  /** true = premier chargement du site : pas d'animation d'entrée (overlay déjà caché) */
  skipEnterAnimation?: boolean;
  /** true = navigation interne (ex: newsletters) — View Transitions gère l'animation */
  noOverlay?: boolean;
};

export default function PageTransition({
  children,
  skipEnterAnimation = false,
  noOverlay = false,
}: PageTransitionProps) {
  const firstBlockVariants: Variants = {
    initial: {
      y: 0,
    },

    enter: {
      y: '-100%',

      transition: {
        duration: 0.8,
        ease: [0.72, 0, 0.3, 0.99],
      },

      transitionEnd: { scaleY: 0, y: '0' },
    },

    exit: {
      scaleY: 1,

      transition: {
        duration: 0.8,
        ease: [0.72, 0, 0.3, 0.99],
      },
    },
  };

  return (
    <>
      {!noOverlay && (
        <motion.div
          animate="enter"
          className="bg-orange pointer-events-none fixed top-0 left-0 z-800 h-full w-full origin-bottom"
          exit="exit"
          initial={skipEnterAnimation ? 'enter' : 'initial'}
          variants={firstBlockVariants}
        />
      )}
      {children}
    </>
  );
}
